// src/features/bookings/components/BookingDetail/tabs/BookingInfoTab.jsx
import React from 'react';
import { BOOKING_TYPE_LABELS, BOOKING_STATUS_LABELS } from '../../../../../shared/utils/formatters';

const BookingInfoTab = ({ booking, editedData, isEditing, onInputChange, styles }) => {
  const d = isEditing ? editedData : booking;
  const noTime = booking.booking_type === 'digital_marketing';

  return (
    <div className={styles.infoGrid}>

      {/* اسم العميل */}
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>اسم العميل</span>
        <span className={styles.icVal}>{booking.client?.name ?? '—'}</span>
      </div>

      {/* رقم الهاتف */}
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>رقم الهاتف</span>
        <span className={styles.icVal}>{booking.client?.phone ?? '—'}</span>
      </div>

      {/* نوع الحجز */}
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>نوع الحجز</span>
        <span className={styles.icVal}>
          {BOOKING_TYPE_LABELS[booking.booking_type] ?? booking.booking_type}
        </span>
      </div>

      {/* الحالة */}
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>الحالة</span>
        <span className={styles.icVal}>
          {BOOKING_STATUS_LABELS[booking.status] ?? booking.status}
        </span>
      </div>

      {/* تاريخ الحجز */}
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>تاريخ الحجز</span>
        {isEditing ? (
          <input
            type="date"
            className={styles.editInput}
            value={d.booking_date ?? ''}
            onChange={e => onInputChange('booking_date', e.target.value)}
          />
        ) : (
          <span className={styles.icVal}>{booking.booking_date ?? '—'}</span>
        )}
      </div>

      {/* موقع التصوير */}
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>موقع التصوير</span>
        {isEditing ? (
          <input
            type="text"
            className={styles.editInput}
            value={d.shooting_location ?? ''}
            onChange={e => onInputChange('shooting_location', e.target.value)}
            placeholder="موقع التصوير"
          />
        ) : (
          <span className={styles.icVal}>{booking.shooting_location ?? '—'}</span>
        )}
      </div>

      {/* وقت التصوير */}
      {!noTime && (
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>وقت التصوير</span>
          {isEditing ? (
            <input
              type="time"
              className={styles.editInput}
              value={d.shooting_time ?? ''}
              onChange={e => onInputChange('shooting_time', e.target.value)}
            />
          ) : (
            <span className={styles.icVal}>{booking.shooting_time ?? '—'}</span>
          )}
        </div>
      )}

      {/* السعر الإجمالي */}
      {booking.booking_type !== 'graduation' && (
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>السعر الإجمالي</span>
          {isEditing ? (
            <input
              type="number"
              step="any"
              className={styles.editInput}
              value={d.total_price ?? ''}
              onChange={e => onInputChange('total_price', e.target.value)}
              placeholder="السعر الإجمالي"
            />
          ) : (
            <span className={styles.icVal}>
              {parseFloat(booking.total_price || 0).toLocaleString('en-US')} د.ع
            </span>
          )}
        </div>
      )}

      {/* الملاحظات */}
      <div className={`${styles.infoCell} ${styles.infoCellFull}`}>
        <span className={styles.icLabel}>ملاحظات</span>
        {isEditing ? (
          <textarea
            className={styles.editTextarea}
            value={d.notes ?? ''}
            onChange={e => onInputChange('notes', e.target.value)}
            placeholder="ملاحظات إضافية..."
            rows={3}
          />
        ) : (
          <span className={styles.icValNote}>{booking.notes ?? '—'}</span>
        )}
      </div>

    </div>
  );
};

export default BookingInfoTab;
